removeAllDots